<enauka-header></enauka-header>
<section class="section-wrapper" id="system">
  <div class="container">
    <div class="row system-wrapper">
      <div class="col">
        <div class="h1">System</div>
        <p>
          Rozwijamy narzędzie, które rewolucjonizuje nauczanie matematyki, opiekując się uczniem od szkoły
          podstawowej aż do zakończenia jego edukacji - w szkole zawodowej,
          liceum czy też renomowanych uczelniach technicznych.
        </p>
        <div class="row mt-4 mb-4 justify-content-center">
          <div class="col-md-6">
            <div class="card system-card">
              <div class="card-body">
                <h5 class="card-title system-icon">
                  <fa-icon icon="book-open"></fa-icon>
                </h5>
                <p class="card-text cbn-text">
                  Dysponujemy zadaniami z matematyki - zaczynając od matematyki elementarnej, kończąc
                  na kursach dla studentów z&nbsp;zakresu analizy matematycznej,
                  algebry, logiki, teorii mnogości, matematyki dyskretnej, rachunku
                  prawdopodobieństwa, równań różniczkowych i analizy zespolonej.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card system-card">
              <div class="card-body">
                <h5 class="card-title system-icon">
                  <fa-icon icon="lightbulb"></fa-icon>
                </h5>
                <p class="card-text cbn-text">
                  Naszą siłą jest wykorzystanie sztucznej inteligencji do personalizacji procesu
                  nauki.
                  Bazując na doświadczeniach ucznia system dobiera zadania adekwatne do jego
                  umiejętności.
                  Wykazujemy się wysoką skutecznością w diagnozie problemów i&nbsp;potrzeb uczniów.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card system-card">
              <div class="card-body">
                <h5 class="card-title system-icon">
                  <fa-icon icon="hands-helping"></fa-icon>
                </h5>
                <p class="card-text cbn-text">
                  Pracujemy z uczniami na różnych poziomach umiejętności. Pomagamy z zaległościami,
                  jak również pracujemy z uczniami nie mającymi trudności z nauką. Wspomagamy przygotowanie
                  do konkursów matematycznych.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card system-card">
              <div class="card-body">
                <h5 class="card-title system-icon">
                  <fa-icon icon="award"></fa-icon>
                </h5>
                <p class="card-text cbn-text">
                  Zwiększamy atrakcyjność nauki, dzięki rozbudowanemu systemowi motywacji. Wirtualne
                  nagrody otrzymywane podczas rozwiązywania zadań sprawiają, że nasi uczniowie chętniej
                  uczą się matematyki.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="join mt-4" id="about">
  <div class="container">
    <div class="row system-wrapper">
      <div class="col-12">
        <article class="p-4">
          <div class="h1">O nas</div>

          <div class="row" style="margin-left:auto;margin-right:auto;">
            <div class="col-md-6" style="margin: auto">
              <video controls="controls" class="video-footer">
                <source src="https://storage.zeszyt.online/storage/movie/demo/tv2020.mp4" type="video/mp4">
                Twoja przeglądarka nie wspiera tego wideo.
              </video>
            </div>
          </div>
          <div class="row" style="margin-left:auto;margin-right:auto;max-width:680px;margin-top:20px">
            <div class="col-md-6 footer-left mb-3"
              title="Kliknij, aby otworzyć linki na stronie głównej Politechniki Warszawskiej">
              <a [routerLink]="['pw']">
                <img class="img-link" src="/shared-assets/images/zeszyt/logo-pw.png" alt="logo PW"></a>
            </div>
            <div class="col-md-6 footer-left mb-3">
              <a class="opinie-hiperlink" [routerLink]="['opinie']"
                title="Kliknij, aby przeczytać opinie nauczycieli na temat zeszyt.online">
                <h2>Opinie<br />nauczycieli</h2>
              </a>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>

<section class="projects section-wrapper" id="projects">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="h1 text-center">Nasze projekty</div>
        <div class="row">
          <div class="col-md-6">
            <div class="card projects-card">
              <div class="card-body">
                <img src="/shared-assets/images/zeszyt/logo-warszawa-sm.png" class="img-fluid projects-card-img"
                  width="250" height="60" alt="logo zakochaj wię w Warszawie">
                <h2 class="card-title h5">Warszawa</h2>
                <p class="project-info">
                  Na poziomie szkół podstawowych wspieramy w Warszawie prowadzenie zajęć matematycznych za pomocą
                  zeszyt.online.
                  Współpracujemy na poziomie dzielnic. Loginy i hasła uczniowie otrzymują od swoich nauczycieli
                  szkolnych.
                  Pomoc organizacyjną zapewniają dzielnicowe wydziały oświaty.<br />
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card projects-card">
              <div class="card-body">
                <img src="/shared-assets/images/zeszyt/logo-mini-fe-sm.png" class="img-fluid projects-card-img"
                  alt="logo MiNI PW i FE" width="250" height="60">
                <h2 class="card-title h5">Matematyka - wstęp do kariery wynalazcy</h2>
                <p class="project-info">
                  Zainteresowanych zapoznaniem się z możliwościami systemu na poziomie klas IV szkół
                  podstawowych zapraszamy do projektu realizowanego przez
                  Wydział Matematyki i Nauk Informacyjnych Politechniki&nbsp;Warszawskiej:<br />
                </p>
                <a href="https://power.mini.pw.edu.pl" class="project-more-info">Matematyka - wstęp do
                  kariery wynalazcy</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="card projects-card">
              <div class="card-body">
                <img src="/shared-assets/images/zeszyt/E8.png" alt="eksperyment 2019/2020" class="img-fluid projects-card-img" width="80"
                  height="60">
                <h2 class="card-title h5">Eksperyment Rzewnie 2019/2020</h2>
                <p class="project-info">
                  Sprawdzaliśmy możliwości zeszyt.online jako narzędzia wspierającego przygotowanie do egzaminu
                  ósmoklasisty.
                  <br>

                </p>
                <span class="project-more-info">
                  <a [routerLink]="['rzewnie']">Wyniki eksperymentu</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="join section-wrapper" id="partnership">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <article class="p-2">
          <div class="h1">Współpraca</div>
          <p style="color: #fff" class="cbn-text">
            Zapraszamy do współpracy administrację publiczną i samorządy. Jesteśmy gotowi do uruchomienia
            systemu zeszyt.online w szkołach po uzyskaniu wsparcia w utrzymaniu infrastruktury i
            współfinansowaniu dalszych prac badawczo-rozwojowych.
          </p>
          <p style="color: #fff;" class="cbn-text">
            Zachęcamy do współpracy zarówno pojedynczych naukowców jak również zespoły z innych uczelni
            wyższych. Interesuje nas sztuczna inteligencja, psychologia, dydaktyka, aspekty społeczne
            edukacji. Pod pewnymi warunkami udostępniamy nasze wewnętrzne narzędzia oraz badawcze wersje
            systemu, które umożliwiają przeprowadzanie specyficznych badań.
          </p>
          <p style="color: #fff; margin-bottom: 0" class="cbn-text">
            Poszukujemy podmiotów gotowych zainwestować w edukację przyszłego pokolenia Polaków.
            Zainteresowanych współfinansowaniem rozwoju edukacji prosimy o kontakt.
            Firmy i osoby prywatne będą mogły pozostać anonimowe albo wyszczególnione jako oficjalni sponsorzy.
            Tym samym uzyskają tytuł "Patrona polskiej edukacji" oraz będą miały możliwość podpisania umowy współpracy.
            Ich wkład będzie promowany na stronach projektu oraz na terenie wspieranej gminy.
            Będą miały możliwość wyboru miasta lub całej gminy, w której uruchomimy system.
            <br />
            <a href="#form" class="btn custom-button default-button" style="margin-top: 20px" enaukaScrollable
              data-menu-selector=".navbar-fade">skontaktuj się, aby uzyskać szczegóły</a>
          </p>
        </article>
      </div>
      <div class="col-lg-6 pt-3 pb-3">
        <div class="embed-responsive embed-responsive-4by3">
          <enauka-carousel [images]="images" [alt]="'Przykłady zadań '" [imageWidth]="700" [imageHeight]="523">
          </enauka-carousel>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="section-wrapper" id="form">
  <div class="container">
    <div class="h1">Formularz kontaktowy</div>
    <p>Aktualnie nie ma możliwości indywidualnego zgłaszania pojedynczych uczniów.</p>
    <enauka-formularz-kontaktowy></enauka-formularz-kontaktowy>
  </div>
</section>
